import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { BRAND_SECTORS } from "@/data/brand-sectors";

/**
 * "Industries" header nav item: a click-to-open dropdown listing the Ernest
 * per-industry landing pages. Drops into the marketing headers in place of a
 * plain nav link, matching their link styling.
 */
const IndustriesDropdown = () => (
  <DropdownMenu>
    <DropdownMenuTrigger className="group inline-flex items-center gap-1 text-foreground/60 font-normal transition-colors duration-300 hover:text-foreground data-[state=open]:text-foreground text-sm lg:text-lg whitespace-nowrap outline-none">
      Industries
      <ChevronDown className="w-4 h-4 transition-transform duration-200 group-data-[state=open]:rotate-180" />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="center" sideOffset={12} className="w-60 rounded-2xl p-1.5">
      {BRAND_SECTORS.map((s) => (
        <DropdownMenuItem key={s.slug} asChild className="rounded-xl px-3 py-2.5 cursor-pointer">
          <Link to={`/industries/${s.slug}`} className="text-base font-normal">
            {s.label}
          </Link>
        </DropdownMenuItem>
      ))}
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild className="rounded-xl px-3 py-2.5 cursor-pointer">
        <Link to="/industries" className="text-base font-medium text-[#584dff]">
          View all industries
        </Link>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

export default IndustriesDropdown;
